/** Server-owned projection. Never read this from caller-authored metadata or
 * infer it from an error's spelling. The raw diagnostic remains in the cache. */
export interface DeliveryFailurePresentation {
  version: 1;
  code: 'meta_authorization_expired' | 'meta_window_closed' | 'meta_window_unknown' | 'channel_missing' | 'channel_inactive' | 'tiktok_unavailable' | 'tiktok_not_initiated' | 'marketing_opted_out' | 'adapter_unavailable';
  source_reason: string;
  provider?: string;
}

export function readDeliveryFailurePresentation(value: unknown, reason: unknown): DeliveryFailurePresentation | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value) || typeof reason !== 'string' || !reason.trim()) return undefined;
  const p = value as Record<string, unknown>;
  if (p.version !== 1 || p.source_reason !== reason) return undefined;
  if (p.code === 'adapter_unavailable') {
    if (typeof p.provider !== 'string' || !p.provider.trim()) return undefined;
    return { version: 1, code: p.code, source_reason: reason, provider: p.provider };
  }
  if (p.provider !== undefined && p.provider !== '') return undefined;
  switch (p.code) {
    case 'meta_authorization_expired': case 'meta_window_closed': case 'meta_window_unknown': case 'channel_missing': case 'channel_inactive': case 'tiktok_unavailable': case 'tiktok_not_initiated': case 'marketing_opted_out':
      return { version: 1, code: p.code, source_reason: reason };
    default:
      return undefined;
  }
}

export function generatedDeliveryFailureText(value: unknown, reason: unknown, translate: (key: string, params?: Record<string, string>) => string): string | undefined {
  const p = readDeliveryFailurePresentation(value, reason);
  if (!p) return undefined;
  return translate('delivery.localFailure.' + p.code, p.code === 'adapter_unavailable' ? { provider: p.provider! } : undefined);
}
